export const mensajesChat = {
  // NewConversationModal.vue — start a new WhatsApp conversation
  newConversation: {
    nameTooShort: "Enter the name you want to be recognized by.",
    saveNameError: "Couldn't save the business name.",
    started: "Conversation started.",
    sent: "Message sent.",
    startError: "Couldn't start the conversation.",
    titleConnect: "Connect your WhatsApp",
    titleName: "Your business name",
    titleNew: "New conversation",
    subtitleConnect: "Required so you can message first",
    subtitleName: "This is the name people will see the message come from",
    subtitleNew: "Message any number on WhatsApp",
    close: "Close",
    senderStripPre: "Will be sent as",
    change: "Change",
    connectBody:
      "To message first, the message has to come from <strong>your own WhatsApp Business number</strong>. With WACheckin's shared number people would see a phone that isn't yours, and we couldn't introduce you under your business name.",
    connectItem1: "Message any number, with or without a booking",
    connectItem2: "Your business name appears as the sender",
    connectItem3: "Replies arrive in this same inbox",
    connectFoot: "Connect once, from Integrations → WhatsApp.",
    previewLabel: "How they'll see it",
    previewGreeting: "Hi 👋",
    previewFromPre: "We're messaging you from",
    previewFromPost: ".",
    previewCtaPre: "We have a message for you. Reply",
    previewOk: "Ok",
    previewCtaPost: "and we'll send it over.",
    fallbackBusiness: "your business",
    nameLabel: "Business name",
    namePlaceholder: "Sunrise Country House",
    nameHelp:
      "It's saved under AI Agent → New bookings, and you can change it there or here whenever you like.",
    recipientLabel: "Recipient",
    messageLabel: "Message",
    messagePlaceholder: "Write your message…",
    cancelSoft: "Not now",
    cancel: "Cancel",
    connectBtn: "Connect WhatsApp",
    continueBtn: "Continue",
    sendBtn: "Send message",
  },

  // MessageTranslate.vue — per-message translation in chat bubbles
  translate: {
    // BarraTraduccion.vue — the chat translator bar (auto-translate + preview)
    off: "Automatic translation off",
    on: "Translating",
    turnOn: "Translate what arrives and preview what you write",
    turnOff: "Turn automatic translation off",
    guestWrites: "the guest writes in {idioma}",
    nothingToDo: "Nothing to translate: the guest writes in {idioma}",
    youRead: "You read it in",
    willBeSentIn: "what you write will be sent in",
    pickOutgoing: "Which language it reaches them in",
    theirs: "theirs",
    willArriveAs: "This is how it will arrive, in {idioma}:",
    sendIn: "Send in {idioma}",
    cancel: "Cancel",
    discard: "Discard",
    enterSends: "Enter sends it",
    translating: "Translating…",
    translate: "Translate",
    viewTranslation: "View translation",
    viewOriginal: "View original",
    translated: "Translated",
    copy: "Copy",
    copied: "Copied",
    error: "Couldn't translate. Please try again.",
  },

  // Phone.vue — WhatsApp-style chatbot preview
  phone: {
    online: "Online",
    today: "Today",
    sampleQuestion: "What time is check-in?",
    answerPlaceholder: "Write your answer here...",
    inputPlaceholder: "Type a message...",
  },

  // selectorTypeIframe.vue — subscription billing period selector
  billing: {
    selectPeriod: "Choose a period",
    selectPeriodHint: "Choose how you want to pay",
    monthly: "Monthly",
    annual: "Annual",
  },

  // GrupoDestinatarios.vue — escribir a un grupo de huéspedes
  grupo: {
    modeLabel: "Who you're writing to",
    modeOne: "Single message",
    modeGroup: "Bulk message",
    allOtas: "All",
    needsWhatsapp: "Connect your WhatsApp to use this channel",
    connectNow: "Connect it",
    varsLabel: "Variable",
    vars: {
      nombre: "The guest's name",
      alojamiento: "The property's name",
      entrada: "The check-in date",
      salida: "The check-out date",
      codigo: "The booking code",
    },
    remove: "Remove",
    oneEach: "Each guest gets it once, through the first available channel.",
    noContact: "1 with no way to reach them | {count} with no way to reach them",
    otaLabel: "Which OTA",
    emoji: "Emoji",
    attach: "Attach a file",
    noFileOta: "The file does not travel through the OTA",
    previewLabel: "How it will read",
    fileTooBig: "“{name}” is {size} MB and WhatsApp's limit for this type is {max} MB",
    fileNotAllowed: "Only images (JPG, PNG, GIF), PDF and MP4 video are allowed: WhatsApp can't play other formats.",
    attachHint: "Images and PDF up to 10 MB · MP4 video up to 15 MB",
    channelLabel: "How",
    channels: { whatsapp: "WhatsApp", email: "Email", ota: "OTA" },
    groupLabel: "Which guests",
    groups: {
      alojados: "Staying now",
      entran_hoy: "Arriving today",
      entran: "Arriving soon",
      salen: "Leaving today",
    },
    withinPre: "within the next",
    withinPost: "day | days",
    empty: "No guests in this group right now.",
    reachOf: "of {total} will get it | of {total} will get it",
    queuedSilently: "1 gets no notice today: they already had one pending | {count} get no notice today: they already had one pending",
    noChannel: {
      whatsapp: "1 with no phone | {count} with no phone",
      email: "1 with no email | {count} with no email",
      ota: "1 with no OTA thread | {count} with no OTA thread",
    },
    billed: "1 WhatsApp conversation is billed | {count} WhatsApp conversations are billed",
    showList: "Show the recipient | Show all {count} recipients",
    hideList: "Hide the list",
    noName: "No name",
    states: {
      directo: "delivered",
      plantilla: "invitation",
      en_cola: "already had one pending",
      sin_telefono: "no phone",
      sin_correo: "no email",
      sin_hilo_ota: "no thread",
      sin_contacto: "no contact",
    },
    sending: "Sending to 1 guest | Sending to {count} guests",
    sendGroup: "Send to 1 guest | Send to {count} guests",
    historial: {
      providerId: "Provider identifier. Use it to look the message up in the SES console.",
      sentMeans: "“Sent” means the provider accepted it. Whether the guest reads it, or whether it lands in spam, is out of our hands.",
      estados: {
        enviando: "Sending",
        enviado: "Sent",
        en_cola: "Queued",
        fallo: "Failed",
        sin_contacto: "No contact details",
      },
      title: "Group messages",
      subtitle: "What was sent, to whom, and what happened to each one",
      empty: "You haven't sent a group message yet.",
      error: "The history could not be loaded.",
      sentBy: "by {quien}",
      running: "Running",
      back: "Back",
      messageLabel: "The message",
      recipientsLabel: "Recipients",
      colName: "Guest",
      colVia: "Channel",
      colDest: "Sent to",
      colState: "Outcome",
      openChat: "Open",
      attachment: "Attachment: {nombre}",
      close: "Close",
      reached: "{enviados} of {total}",
      noOne: "No name",
    },
  },
};
